// Extend the Window interface to include recaptchaSiteKey
declare global {
  interface Window {
    recaptchaSiteKey: string;
  }
}

export async function getRecaptchaToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (typeof grecaptcha === "undefined") {
      reject(new Error("reCAPTCHA script not loaded"));
      return;
    }

    grecaptcha.ready(async () => {
      try {
        const token = await grecaptcha.execute(window.recaptchaSiteKey, {
          action: "LOGIN",
        });
        resolve(token);
      } catch (error) {
        console.error("Error getting reCAPTCHA token:", error);
        reject(error);
      }
    });
  });
}
